import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-399"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M4.795 2.361c1.603 2.483 3.514 5.88 3.514 7.226a3.514 3.514 0 1 1-7.028 0c0-1.346 1.91-4.743 3.514-7.226m0-1.802S.28 7.092.28 9.587a4.514 4.514 0 1 0 9.028 0C9.309 7.092 4.795.56 4.795.56zm8.417 7.79a10.83 10.83 0 0 1 1.569 3.304 1.569 1.569 0 1 1-3.138 0 10.83 10.83 0 0 1 1.569-3.304m0-1.833s-2.569 3.717-2.569 5.137a2.569 2.569 0 1 0 5.138 0c0-1.42-2.569-5.137-2.569-5.137z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }